<template>
    <div>
        <div class="link">
            <img :src="$global.Image.no_link" alt="" class="no" />
            <div class="txt">您的权限暂未开放～</div>
            <div class="back" @click="back">返回首页</div>
        </div>
        <img :src="$global.Image.icon_company" alt="" class="company" />
    </div>
</template>
<script>
export default {
    name: "jurisdiction",
    data() {
        return {};
    },
    methods: {
        back(){
            this.$router.go(-1)
        }
    }
};
</script>
<style lang="less" scoped>
.link {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    background: url("../assets/icon/icon_back.png") no-repeat;
    background-size: 100% 100%;
    .no {
        width: 166px;
        height: 133px;
        margin-top: 400px;
    }
    .txt {
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        padding-top: 24px;
    }
    .back {
        width: 180px;
        height: 49px;
        line-height: 49px;
        text-align: center;
        background: #ffffff;
        border-radius: 2px;
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #013fb6;
        margin-top: 50px;
        cursor: pointer;
    }
}
.company {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 77px;
    width: 898px;
    height: 80px;
}
</style>
